import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Questionnaire from './pages/Questionnaire'
import Results from './pages/Results'

function App() {
  return (
    <div className="min-h-dvh bg-white">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/questionnaire/:sessionId" element={<Questionnaire />} />
        <Route path="/results/:sessionId" element={<Results />} />
      </Routes>
    </div>
  )
}

export default App
